// Legal identity used across every policy page. Edit here once.
export const company = {
  brand: 'MarineForceLED',
  /**
   * Public-facing seller name. Intentionally the brand only — the owning entity is
   * not displayed. Register "MarineForceLED" as a fictitious name (DBA) of the entity
   * so this name legally refers to it.
   */
  legalName: 'MarineForceLED',
  website: 'marineforceled.com',
  supportEmail: 'support@marineforceled.com',
  privacyEmail: 'privacy@marineforceled.com',
  /** Inbox that receives every website form (support, warranty claims, reviews for approval). */
  formsEmail: 'support@marineforceled.com',
  /** Mailing address for legal notices. Shown on policy pages when filled in. */
  mailingAddress: '',
  /** State whose law governs the Terms and where arbitration is seated. */
  governingState: 'Florida',
  policiesUpdated: 'October 10, 2026',
  returnWindowDays: 30,
  damageReportDays: 7,
  restockingFeePct: 15,
  processingDays: '1–3 business days',
  deliveryEstimate: '3–7 business days',
  batteryCoverageYears: 1,
};
